import { http } from "../http-common";


const getActiveRoles = () => {
  return http.get(
    `/role-management/getActiveRoles?isAdministrator=true&status=true&isRolePage=true`
  );
};
const getRole = (page = 0, pageSize = 10) => {
  return http.get(`/role-management?isAdministrator=true&pageNumber=${page}&pageSize=${pageSize}`);
};


const getCuringById = ({ id }) => {
  return http.get(
    `culture/{cuCultureId}?cuCultureId=${id}&pageNumber=0&pageSize=10`
  );
};

const updateRole = (data) => {
  return http.put(`/role-management`, data);
};


const createRole = (data) => {
  return http.post(
    `/role-management`, data
  );
};

const deleteManure = ({id}) => {
  return http.delete(`/greenManure/${id}`)
}

// const searchCuringUnitName = ({
//   tobaccoGroup,
//   status,
//   isNew,
//   countryCode,
//   curingUnitName,
//   page,
//   size,
// }) => {
//   const params = {
//     tobaccoGroup,
//     status,
//     isNew,
//     countryCode,
//     curingUnitName,
//     pageNumber: page,
//     pageSize: size,
//   };
//   const filteredEntries = Object.entries(params).filter(([key, value]) => value != "");
//   let newParams = Object.fromEntries(filteredEntries);
//   newParams['pageNumber'] = params.pageNumber
//   return http.get('/curingunit/search', { params: newParams });
// };



const searchManureData = (keyword) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`);
};


const searchRole = (query,page,size) => {
  return http.get(`/role-management?keyword=${query}&isAdministrator=true&pageNumber=${page}&pageSize=${size}`);
};

const getAllCuringData = (countryCode) => {
  return http.get(`curingunit/allCuringUnits?countryCode=${countryCode}`);
};

const filterManure = (keyword,status) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}&status=${status}`);
};

const filterManureAutocomplete = (keyword) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`);
};

const fetchDelegation = (batOneId) => {
  return http.get(`/delegation/${batOneId}`);
};
const updateDelegation = (data) => {
  return http.put(`/delegation/${data?.delegation}?username=${data?.userName}`);
};

const AdministratorService = {
  getActiveRoles,
  getRole,
  createRole,
  getAllCuringData,
  getCuringById,
  searchManureData,
  updateRole,
  deleteManure,
  searchRole,
  filterManure,
  filterManureAutocomplete,
  fetchDelegation,
  updateDelegation
};
export default AdministratorService;

